import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from 'react-loader-advanced';
import CustomCircleLoader from './CustomCircleLoader';
import s from './Loader.css';

const FullPageLoader = ({ children, show = false }) => {
  const spinner = () => <CustomCircleLoader size={48} />;

  return (
    <Loader
      show={show}
      message={spinner()}
      foregroundStyle={{ color: 'white' }}
      backgroundStyle={{ backgroundColor: 'rgba(249, 249, 249, 0.74)' }}
    >
      <div>{children}</div>
    </Loader>
  );
};

FullPageLoader.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired
};

FullPageLoader.defaultProps = {
  show: false
};

export default withStyles(s)(FullPageLoader);
